// extracted by mini-css-extract-plugin
export default {"container":"AWSIntro_container__FKfcj","intro":"AWSIntro_intro__+1+fE","subintro":"AWSIntro_subintro__Njv6C"};